<template>
        <div class="warp">
            <!-- 面包屑 -->
             <breadcrumb :back="true" :crubList="[{name:'成果展示管理'},{name:'成果展示列表',goback:true},{name:'编辑成果展示'}]" :title="'编辑成果展示'"/>
            <!-- 表单 -->
            <div class="box">
                <div class="forms">
                    <div class="child">
                        <div class="name"><span>*</span>银行名称：</div>
                        <div class="content">
                          <el-input v-model="sendInfo.bankName" maxlength="20" placeholder="请输入"></el-input>
                        </div>
                    </div>
                    <div class="error" v-if="errors['sendInfo.bankName']">错误提示：{{errors['sendInfo.bankName']}}</div>
                    <template v-if="tab === '0'">
                        <div class="child">
                            <div class="name"><span>*</span>产品数量：</div>
                            <div class="content">
                              <el-input v-model.number="sendInfo.amount" maxlength="9" placeholder="请输入"></el-input>
                            </div>
                        </div>
                        <div class="error" v-if="errors['sendInfo.amount']">错误提示：{{errors['sendInfo.amount']}}</div>
                        <div class="child">
                            <div class="name"><span>*</span>交易成功笔数：</div>
                            <div class="content">
                              <el-input v-model.number="sendInfo.acceptAmount" maxlength="9" placeholder="请输入"></el-input>
                            </div>
                        </div>
                        <div class="error" v-if="errors['sendInfo.acceptAmount']">错误提示：{{errors['sendInfo.acceptAmount']}}</div>
                        <div class="child">
                            <div class="name"><span>*</span>撮合交易金额：</div>
                            <div class="content">
                              <!-- <el-input v-model="sendInfo.moneyAmount" maxlength="20" placeholder="请输入"></el-input> -->
                              <m-input v-model="sendInfo.moneyAmount" :validatorType="2" :maxlength="9" placeholder="请输入"></m-input>
                            </div>
                        </div>
                        <div class="error" v-if="errors['sendInfo.moneyAmount']">错误提示：{{errors['sendInfo.moneyAmount']}}</div>
                    </template>
                    <template v-else>
                        <div class="child">
                            <div class="name"><span>*</span>放款户数：</div>
                            <div class="content">
                              <el-input v-model.number="sendInfo.amount" maxlength="9" placeholder="请输入"></el-input>
                            </div>
                        </div>
                        <div class="error" v-if="errors['sendInfo.amount']">错误提示：{{errors['sendInfo.amount']}}</div>
                        <div class="child">
                            <div class="name"><span>*</span>放款笔数：</div>
                            <div class="content">
                              <el-input v-model.number="sendInfo.acceptAmount" maxlength="9" placeholder="请输入"></el-input>
                            </div>
                        </div>
                        <div class="error" v-if="errors['sendInfo.acceptAmount']">错误提示：{{errors['sendInfo.acceptAmount']}}</div>
                        <div class="child">
                            <div class="name"><span>*</span>放款金额：</div>
                            <div class="content">
                              <m-input v-model="sendInfo.moneyAmount" :validatorType="2" :maxlength="11" placeholder="请输入"></m-input>
                              <!-- <el-input v-model.number="sendInfo.moneyAmount" maxlength="20" placeholder="请输入"></el-input> -->
                            </div>
                        </div>
                        <div class="error" v-if="errors['sendInfo.moneyAmount']">错误提示：{{errors['sendInfo.moneyAmount']}}</div>
                    </template>
                    <div class="child">
                            <div class="name"></div>
                            <div class="content">
                              <div class="singleBtn">
                                  <el-button type="primary" size="small" @click="submit">保存</el-button>
                                  <el-button  size="small" @click="onCanel">取消</el-button>
                                </div>
                            </div>
                        </div>
                    
                </div>
            </div>
        </div>
</template>

<script>
import {API} from "@/axios/config";
import breadcrumb from '../../components/breadcrumb';
import upLoadFiles from '../../components/upLoadFiles';
import wangEnduit from '../../components/Editor/index';
import mInput from '@/components/Input/index'
import {getDict} from "@/axios";
import Regular from "@/mixins/regular.js";
export default {
    components:{
        breadcrumb,
        upLoadFiles,
        wangEnduit,
        mInput
    },
    data(){
        return{
          tab:'0',
			    id:'',
            sendInfo:{
                id:void 0,// ，编辑时必传
                achievementType:void 0,
                acceptAmount: void 0, 
                amount: void 0,
                bankName:void 0,
                moneyAmount: void 0,
            }
        }
    },
    computed: {
        errors() {
            return this.$vuerify.$errors // 错误信息会在 $vuerify.$errors 内体现
        }
    },
	created() {
		const {id,tab} = this.$route.params
    this.tab = tab || '0'
		if(id){
		  this.id=id;
		 	this.sendInfo.id=id;
			this.getDetail();
		}
		
	},
    vuerify: {
		'sendInfo.bankName':{
		    test:function(val){
		        if(val){
		            return true;
		        }else{
		            return false;
		        }
		    },
		    message:'必填项不能为空'
		},
		'sendInfo.amount':{
		    test:function(val){
            this.$vuerify.$errors['sendInfo.amount'] = this.tab === '0'?'请输入产品数量':'请输入放款户数'
		        if(val){
                if (!Number.isInteger(val)) {
                  this.$vuerify.$errors['sendInfo.amount'] = '请输入数字值'
                  this.sendInfo.amount = void 0
                  return false
                } else {
                  if (val > 999999999) {
                    this.$vuerify.$errors['sendInfo.amount'] = '必须小于999999999'
                    return false
                  } else {
                    return true
                  }
                }         
		            
		        }
		    },
		    message:'必填项不能为空'
		},
        'sendInfo.acceptAmount':{
            test:function(val){
              this.$vuerify.$errors['sendInfo.acceptAmount'] = this.tab === '0'?'请输入交易成功笔数':'请输入放款笔数'
                if(val){
                    if (!Number.isInteger(val)) {
                  this.$vuerify.$errors['sendInfo.acceptAmount'] = '请输入数字值'
                  this.sendInfo.acceptAmount = void 0
                  return false
                } else {
                  if (val > 999999999) {
                    this.$vuerify.$errors['sendInfo.acceptAmount'] = '必须小于999999999'
                    return false
                  } else {
                    return true
                  }
                }   
                }else{
                    return false;
                }
            },
            message:'必填项不能为空'
        },
        'sendInfo.moneyAmount':{
            test:function(val){
              this.$vuerify.$errors['sendInfo.moneyAmount'] = this.tab === '0'?'请输入撮合交易金额':'请输入放款金额'
                if(val){
                    let aa = val.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')
                    if (aa) {
                      this.sendInfo.moneyAmount = aa
                      return true;
                    }else {
                      this.$vuerify.$errors['sendInfo.moneyAmount']= '只能是数字或小数点保留两位小数'
                      this.sendInfo.moneyAmount = void 0
                      return false
                    }
                    
                }else{
                    return false;
                }
            },
            message:'必填项不能为空'
        }
    },
    methods:{
      // 验证输入类型为2
    // checkInput() {
    //   if (String(this.sendInfo.moneyAmount) === '00') {
    //     this.sendInfo.moneyAmount = '0'
    //   }
    //   this.sendInfo.moneyAmount = this.sendInfo.moneyAmount.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')
    // },
      onCanel(){
        this.$router.back(-1)
      },
		getDetail(){
			this.$axiosc.get('/backstage/achievementDisplay/details/'+this.id).then((r)=>{
			    if(r.code==200){
              const param = {
                id:this.id,// ，编辑时必传
                achievementType:parseInt(this.tab),
                acceptAmount: r.data.acceptAmount, 
                amount: r.data.amount,
                bankName: r.data.bankName,
                moneyAmount: r.data.moneyAmount?r.data.moneyAmount.toString(): void 0,
              }
					
					this.sendInfo=param;
			    }else{
			        this.$alert(r.msg)
			    }
			})
		},
        //提交
        submit:function(){
            this.$vuerify.clear();
            if(this.$vuerify.check()){
              const param = {...this.sendInfo}
              param.achievementType = parseInt(this.tab)
              param.moneyAmount = parseFloat(param.moneyAmount)
              this.$axioscBody.post('/backstage/achievementDisplay/save',param).then((r)=>{
                if(r.code==200){
                  this.$message({
                    type: 'success',
                    message: r.msg
                  });
                  this.$router.back();
                }else{
                  this.$alert(r.msg);
                }
              })
            }
        },
        
    }
}
</script>

<style lang="scss" scoped>
.warp{
    height:calc(100% - 40px);
     overflow: hidden;
    .box{
        
        padding:20px 0 ;
        height:calc(100% - 50px);
     overflow-x: hidden;
     overflow-y: auto;
        .forms{
            max-width: 750px;
            margin: auto;
            .child{
                .content{
                    flex: 1;
					.el-textarea{
						width: 100% !important;
					}
                }
				/deep/ .el-select{
					width: 100% !important;
				}
				
				.name{
					width: 150px !important;
					text-align: right;
				}
            }
			.hint{
				padding-left: 100px;
			}
			.singleBtn{
				text-align: left;
			}
			.error{
				padding-left: 100px;
			}
        }
    }
}
</style>